import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Dropdown from 'react-dropdown'
import { languageByCode } from 'utils'

import { fetchAndSwitchLocale } from 'actions/ui'

import {
  updateEventLanguageAction,
  updateCellarLanguageAction,
} from 'actions/languages'

const LOCALES = ['en', 'it', 'de', 'bg']

class LocaleSwitcher extends React.Component {
  switchLocale({ value }) {
    const {
      setLocale,
      updateEventLanguage,
      updateCellarLanguage,
    } = this.props

    const uiLocale = LOCALES.indexOf(value) > -1 ? value : 'en'

    updateEventLanguage(value)
    updateCellarLanguage(value)
    setLocale(uiLocale)
  }

  render() {
    const { languages } = this.props

    return (
      <div className="dropdown__input">
        <Dropdown
          options={languages.selectLanguages}
          onChange={this.switchLocale.bind(this)}
          value={languageByCode(languages.eventLanguage, languages.selectLanguages)}
        />
      </div>
    )
  }
}

LocaleSwitcher.propTypes = {
  languages: PropTypes.object.isRequired,
  setLocale: PropTypes.func.isRequired,
  updateEventLanguage: PropTypes.func.isRequired,
  updateCellarLanguage: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    languages: state.languages,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setLocale: fetchAndSwitchLocale,
    updateEventLanguage: updateEventLanguageAction,
    updateCellarLanguage: updateCellarLanguageAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleSwitcher)
